export default {"src":"/_next/static/media/contribution1.ef988c02.svg","height":100,"width":136,"blurWidth":0,"blurHeight":0};